import { isPresent } from 'ts-is-present';
import { Action } from '../../../../../v2BaseComponents/ActionButtonLayout/types';
import { useAddFolderAction } from './useAddFolderAction';
import { useDeleteFolderAction } from './useDeleteFolderAction';
import { useEditFolderAction } from './useEditFolderAction';
import { useMoveFolderAction } from './useMoveFolderAction';
import { useHasPermission } from '../../../../../v2BaseComponents/Permissions/hooks';

export type UseFolderActionsArgs = {
    folderId: string;
    medicalProfileId: string;
    onSetFolderId: (folderId: string) => void;
    folderOrganizationId: string | null;
};

export type UseFolderActionsReturnValue = {
    actions: Action[];
    Prompts: React.ReactNode;
};

export const useFolderActions = (args: UseFolderActionsArgs): UseFolderActionsReturnValue => {
    const hasPermission = useHasPermission(args.medicalProfileId, 'files', 'edit');
    const add = useAddFolderAction(args);
    const edit = useEditFolderAction(args);
    const move = useMoveFolderAction(args);
    const del = useDeleteFolderAction(args);

    if (!hasPermission) return { actions: [], Prompts: null };

    return {
        actions: [add.action, edit.action, move.action, del.action].filter(isPresent),
        Prompts: (
            <>
                {add.Prompt}
                {edit.Prompt}
                {move.Prompt}
                {del.Prompt}
            </>
        ),
    };
};
